export default {
  // General UI elements
  save: "Speichern",
  saving: "Speichern",
  cancel: "Abbrechen",
  edit: "bearbeiten",
  delete: "Löschen",
  profile: "Profil",
  settings: "Einstellungen",
  logout: "Abmelden",
  language: "Sprache",
  loading: "Laden",
  submit: "Absenden",
  search: "Suchen...",
  back: "Zurück",
  next: "Weiter",
  previous: "Zurück",
  continue: "Fortfahren",
  done: "Fertig",
  error: "Fehler",
  success: "Erfolg",
  warning: "Warnung",
  info: "Information",
  close: "Schließen",
  open: "Öffnen",
  yes: "Ja",
  no: "Nein",
  ok: "OK",
  
  // Authentication
  auth: {
    signIn: "Anmelden",
    signUp: "Registrieren",
    signOut: "Abmelden",
    forgotPassword: "Passwort vergessen?",
    resetPassword: "Passwort zurücksetzen",
    sendResetLink: "Link zum Zurücksetzen senden",
    createAccount: "Konto erstellen",
    alreadyHaveAccount: "Bereits ein Konto?",
    dontHaveAccount: "Noch kein Konto?",
    or: "Oder",
    continueWith: "Fortfahren mit",
    google: "Google",
    facebook: "Facebook",
    apple: "Apple",
    twitter: "Twitter",
    passwordRequirements: "Passwort muss mindestens 8 Zeichen lang sein",
    passwordMatch: "Passwörter müssen übereinstimmen",
    emailInvalid: "Bitte gib eine gültige E-Mail-Adresse ein"
  },
  
  // Profile specific
  username: "Benutzername",
  email: "E-Mail",
  password: "Passwort",
  confirmPassword: "Passwort bestätigen",
  joinDate: "Beitrittsdatum",
  streak: "Serie",
  xp: "XP",
  plan: "Plan",
  free: "Kostenlos",
  pro: "Pro",
  premium: "Premium",
  referralCode: "Empfehlungscode",
  share: "Teilen",
  copy: "Kopieren",
  copied: "Kopiert!",
  contactUs: "Kontaktiere uns",
  termsOfService: "Nutzungsbedingungen",
  privacyPolicy: "Datenschutzrichtlinie",
  accountSettings: "Kontoeinstellungen",
  changePassword: "Passwort ändern",
  deleteAccount: "Konto löschen",
  deleteAccountConfirm: "Bist du sicher, dass du dein Konto löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
  updateProfile: "Profil aktualisieren",
  profileUpdated: "Profil erfolgreich aktualisiert",
  memberSince: "Mitglied seit",
  noSetsYet: "Noch keine Sets :(",
  upgradeToPro: "Auf Pro Upgraden",
  recentActivity: "Letzte Aktivität",
  shareWithAFriend: "Mit einem Freund teilen",
  contactTheTeam: "Das Team Kontaktieren",
  termsAndConditions: "Allgemeine Geschäftsbedingungen",
  editUsername: "Benutzernamen Bearbeiten:",
  logOut: "Abmelden",
  usernameError1: "Benutzername darf nicht leer sein",
  usernameError2: "Bitte gib einen anderen oder neuen Benutzernamen ein",
  usernameError3: "Benutzername darf keine Leerzeichen enthalten",
  usernameError4: "Benutzername darf keine Großbuchstaben enthalten",
  usernameError5: "Benutzername darf keine Sonderzeichen enthalten",
  usernameError6: "Benutzername muss zwischen 4 und 18 Zeichen lang sein",
  usernameError7: "Benutzername enthält unangemessene Inhalte",
  usernameError8: "Dieser Benutzername ist bereits vergeben",
  clickOrDragAndDrop: "Klicke oder ziehe und lass los, um hochzuladen",
  confirm: "Bestätigen",
  retake: "Erneut Aufnehmen",

  // BottomNav
  profile: "Profil",
  home: "Home",
  library: "Meine Bibliothek",
  saved: "Gespeichert",
  rankings: "Ranglisten",

  // Feature
  backToLibrary: "Zurück zur Bibliothek",
  exploreSets: "Sets Erkunden",
  communitySets: "Community Sets",
  mySets: "Meine Sets",
  alreadyAdded: "Bereits hinzugefügt",
  addToLibrary: "Zur Bibliothek hinzufügen",
  loading: "Laden...",
  loadMoreSets: "Mehr Sets laden",
  by: "Von",
  makePublic: "Öffentlich machen",
  subscriptionRequired: "Abonnement Erforderlich",
  subscriptionRequiredMessage: "Du kannst nur 10 sets gleichzeitig in der bibliothek haben. Upgrade zu premium für unbegrenzte sets!",

  // My Library
  deleteSet: "Set Löschen",
  deleteSetConfirmation: "Bist du sicher, dass du dieses Set löschen möchtest?",
  yesDelete: "Ja, Löschen",
  collections: "Öffentliche Sets",
  myLibrary: "Meine Bibliothek",
  outOf10Sets: "von 10 Sets hinzugefügt.",
  switchBackToPro: "Zurück zu Pro",
  upgradeToPro: "Upgrade zu Pro",
  outOf10OnFree: "von 10 auf kostenlos.",
  letMeCook: "Lass mich kochen",
  selectMode: "Modus auswählen",
  multipleChoice: "Mehrfachwahl",
  flashcards: "Lernkarten",
  freeResponse: "Freie Antwort",
  proOnly: "Nur für Pro",
  leaderboard: "Bestenliste",
  favorites: "Favoriten",
  profile: "Profil",
  reportBugs: "Melden Sie Fehler",

  // Question Card
  correctMessage: "Richtig! Gut Gemacht.",
  typeYourAnswer: "Schreibe deine antwort...",
  submitAnswer: "Antwort Absenden",
  responseCannotBeBlank: "Antwort darf nicht leer sein",
  noAnswerAvailable: "Keine Antwort verfügbar",
  answerGuideline: "Antwortleitfaden",
  pleaseSubmitAnswerFirst: "Bitte antworte zuerst",
  revealAnswer: "Antwort Anzeigen",
  hideAnswer: "Antwort Verbergen",
  gradingInProgress: "Benotung läuft...",
  grading: "Benotung",
  answerGuidelines: "Antwortrichtlinien",
  finalScore: "Endpunktzahl:",
  evaluateAnswer: "Antwort Bewerten",

  // Saved
  favorites: "Favoriten",
  searchQuestions: "Fragen suchen...",
  noSavedQuestions: "Noch keine gespeicherten fragen.",

  // Scroller
  loadingMoreQuestions: "Mehr Fragen Werden Geladen",

  // New Prompt
  deleteSet: "Set Löschen",
  deleteSetConfirmation: "Bist du sicher, dass du dieses Set löschen möchtest?",
  yesDelete: "Ja, Löschen",
  cancel: "Abbrechen",
  setLimitReached: "Set-Limit Erreicht",
  setLimitError: "Du kannst nur 10 Sets gleichzeitig in der bibliothek haben. Upgrade zu Premium für unbegrenzte sets!",
  close: "Schließen",
  uploadNotes: "Notizen Hochladen",
  general: "Allgemein",
  title: "Titel",
  setTitleMessage: "Setze einen Titel für deine AI generierten Cookr Fragen, damit es später leichter ist, darauf zuzugreifen.",
  titleError1: "Titel darf nicht leer sein",
  titleError2: "Titel enthält unangemessene inhalte",
  content: "Inhalt",
  setContentMessage: "Kopiere und füge deine notizen, vorlesungen oder andere textuelle inhalte ein.",
  contentError1: "Inhalt darf nicht leer sein",
  contentError2: "Inhalt enthält unangemessene inhalte",
  subject: "Thema",
  setSubjectMessage: "Was ist das thema oder topic dieses inhalts?",
  subjectError1: "Thema darf nicht leer sein",
  subjectError2: "Thema enthält unangemessene inhalte",

  // Payment Confirmation
  returnToProfile: "Zurück zum Profil",

  // Plans
  confirmSwitch: "Wechsel zu Free Plan Bestätigen",
  confirmSwitchMessage: "Bist du sicher, dass du zum Free Plan wechseln möchtest? Du verlierst Zugriff auf Premium Features.",
  buttonConfirm: "Wechsel Bestätigen",
  processing: "Wird Verarbeitet...",
  unlimitedScrolling: "Unbegrenztes Scrollen",
  unlimitedSubjects: "Unbegrenzte Themen",
  aiTutorBot: "AI Tutor Bot",
  newFeatureAccess: "Zugriff auf Neue Features",
  saveScrolls: "Scrolls Speichern",
  infiniteNoteUploads: "Unendliche Notiz Uploads",
  answerExplanations: "Antwort Erklärungen",
  shareScrolls: "Scrolls Teilen",
  everythingInStandard: "Alles in Standard",
  current: "Aktuell",
  switchOver: "Wechseln",
  forever: "/für immer",
  monthly: "/monatlich",
  yearly: "/jährlich",

  // Leaderboard
  leaderboard: "Bestenliste",

  // Home.js
  pickASubject: "Wähle ein thema, um deine sitzung zu starten!",

  // scrollerLoader
  generatingContent: "Inhalt Wird Generiert...",

  // Dropdown
  choose: "Wähle",
  titleTooLong: "Der Titel darf nicht mehr als 100 Zeichen enthalten", 


}
